export default "__VITE_ASSET__B9Xe3gd9__"